import styled from "@emotion/styled";
import { ExploreSideBarLayout } from "@kaltura/mediaspace-shared-search";

export const StyledAllContentContainer = styled(ExploreSideBarLayout)(({ theme }) => ({
    flexGrow: 1,
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(3),
    },
}));

export const StyledResultsContainer = styled("div")(({ theme }) => ({
    flex: "1 1 0",
    minWidth: 0,
    "& .kms-ds-my-media-results.kms-ds-my-media-results": {
        // override inner style
        marginTop: theme.spacing(3),
    },
}));
